import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import internal from 'stream';
import { AgentActivityReportResponse } from '../../interfaces/Reporting/AgentActivityReportResponse';
import { ChatRatingReportResponse } from '../../interfaces/Reporting/ChatRatingReportResponse';
import { GetReportingStatsResponse } from '../../interfaces/Reporting/GetReportingStatsResponse';
import { SchedulingReportResponse } from '../../interfaces/Reporting/SchedulingReportResponse';
import { SendDigestReport } from '../../interfaces/Reporting/SendDigestReport';
import { TranscriptsDailyCountResponse } from '../../interfaces/Reporting/TranscriptsDailyCountResponse';
import { TranscriptsHourlyStatisticsResponse } from '../../interfaces/Reporting/TranscriptsHourlyStatisticsResponse';
import { environment } from '@env/environment';
import { getContext } from '@app/core';

@Injectable({
  providedIn: 'root',
})
export class ReportingService {
  constructor(private httpClient: HttpClient) {}

  fetchReportingStats(userId: string, accountId: string, campaignId: string, from: Date, to: Date) {
    const url = `/insights/getChatReportingStats?UserId=${userId}&AccountId=${accountId}&CampaignId=${campaignId}&From=${from}&To=${to}`;
    return this.httpClient.get<GetReportingStatsResponse>(url);
  }

  fetchTranscriptsAverageCountHourly(from: string, to: string, campaignId: string) {
    const url = `/insights/getTranscriptsAverageCountHourly?CampaignId=${campaignId}&From=${from}&To=${to}`;
    return this.httpClient.get<TranscriptsHourlyStatisticsResponse>(url);
  }

  fetchTranscriptsCountDaily(campaignId: string, from: Date, to: Date) {
    const url = `/insights/getTranscriptsCountDaily?CampaignId=${campaignId}&From=${from}&To=${to}`;
    return this.httpClient.get<TranscriptsDailyCountResponse>(url);
  }

  fetchWeeklyActivity(
    accountId: string,
    campaignId: string,
    email: string,
    name: string,
    firstName: string,
    lastName: string,
    isOnline: string,
    isActive: string,
    type: number,
    appType: number,
    from: Date,
    to: Date,
    digestReportPeriod: number
  ) {
    const url = `/insights/agentActivityReport?AccountId=${accountId}&CampaignId=${campaignId}&Email=${email}&name=${name}&firstName=${firstName}&LastName=${lastName}&IsOnline=${isOnline}&IsActive=${isActive}&Type=${type}&AppType=${appType}&From=${from}&To=${to}&DigestReportPeriod=${digestReportPeriod}`;
    return this.httpClient.get<AgentActivityReportResponse>(url);
  }

  fetchChatRatingReport(campaignId: string, from: Date, to: Date, digestReportPeriod: number) {
    const url = `/insights/chatRatingReport?CampaignId=${campaignId}&From=${from}&To=${to}&DigestReportPeriod=${digestReportPeriod}`;
    return this.httpClient.get<ChatRatingReportResponse>(url);
  }

  fetchSchedulingReport(campaignId: string, from: Date, to: Date, digestReportPeriod: number) {
    const url = `/insights/schedulingReport?CampaignId=${campaignId}&From=${from}&To=${to}&DigestReportPeriod=${digestReportPeriod}`;
    return this.httpClient.get<SchedulingReportResponse>(url);
  }

  sendDigestReportEmail(data: SendDigestReport) {
    const url = '/insights/sendDigestReport';
    return this.httpClient.post(url, data, { context: getContext('messenger') });
  }
}
